import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import { removeQueryStringParam } from 'shared/helpers/UrlHelper'
import { QUERY_PARAM } from 'LiveBoard/config/constants'
import { Tooltip } from 'shared/UI/TooltipNew'
import RoutesService from 'LiveBoard/services/routes'
import get from 'lodash/get'
import { isDownArrowKey, isEnterKey, ACCESSIBILITY_CLASSES, TAB_INDEX_INDICATIONS } from 'shared/helpers/AccessibilityHelper'

const Category = props => {
  const [isHover, setIsHover] = useState(false)

  const location = useLocation()

  const handleClick = () => {
    props.onSelect(props.category.id)
  }

  const onMouseEnter = () => {
    setIsHover(true)
  }

  const onMouseLeave = () => {
    setIsHover(false)
  }

  const selectedCategoryCSS = get(props.categoryCSS, 'selected' ,{})
  const hoveredCategoryCSS =  get(props.categoryCSS, 'hover' ,{})
  const defaultCategoryCSS =  get(props.categoryCSS, 'default' ,{})
  const isSelected = props.selectedCategoryId == props.category.id
  const style = isSelected ? selectedCategoryCSS : (isHover ? hoveredCategoryCSS : defaultCategoryCSS)
  const accessibilityClass = props.categoryTheme === 'classic' ? ACCESSIBILITY_CLASSES.main : ACCESSIBILITY_CLASSES.withOffset
  const searchParams = removeQueryStringParam(location.search, QUERY_PARAM)
  const categoryRoute = RoutesService.getCategoryRoute(props.category, props.board) + searchParams

  const focusFirstItemTile = () => {
    let itemElements = document.querySelectorAll('.item-tile')
    if (itemElements.length === 0) {
      return
    }
    let firstItemElement = itemElements[0]
    firstItemElement.focus()
  }

  const onKeyboardClick = (e) => {
    if (isDownArrowKey(e)) {
      focusFirstItemTile()
    } else if (isEnterKey(e)) {
      handleClick(e)
    }
  }

  return (
    <div
      className={`category ${accessibilityClass}`}
      style={style.tab}
      onClick={handleClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onKeyDown={onKeyboardClick}
      tabIndex={TAB_INDEX_INDICATIONS.normalFlow}
    >
      <Tooltip
        text={props.category.name}>
        <Link
          style={style.link}
          tabIndex={TAB_INDEX_INDICATIONS.skip}
          to={categoryRoute}>
          {props.category.name}
        </Link>
      </Tooltip>
    </div>
  )
}

Category.propTypes = {
  board: PropTypes.object.isRequired,
  category: PropTypes.object.isRequired,
  selectedCategoryId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onSelect: PropTypes.func,
  categoryCSS: PropTypes.object
}

export default Category
